import { User } from "@snubes/snubes-types";

export function getSelectedOrganizationId(user: User | undefined) {
  console.log("selectedOrganizationId: " + user?.selectedOrganizationId);
  console.log("organizationIds[0]: " + user?.organizationIds[0]);
  return user?.selectedOrganizationId || user?.organizationIds[0];
}
